// import I18n from "i18n-js";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Group } from "@domain/group/group";
import { useIsMobile } from "@utils/hooks";
// import { useMembersEditor } from "../../components/group/useMembersEditor";
import { CreatePostInput } from "@ui/components/post/createPostInput";
import { FeedList } from "@ui/components/post/feedList";
import { gap, mobile } from "@ui/styles/utils";
// import { InvitationButton } from "../profilePage/invitationButton";
import { GroupMembersList } from "./groupMembersList";

interface GroupActivityProps extends React.HTMLAttributes<HTMLDivElement> {
	group: Group;
}

export const GroupActivity: React.FC<GroupActivityProps> = ({ group, ...htmlProps }) => {
	const history = useHistory();
	// const openMembersModal = useMembersEditor(group || undefined, group?.userRole);

	// const isAdmin = group?.userRole === "ADMINISTRATOR";
	// const canSendInvitations = group?.type === "DISCUSSION_GROUP" && group?.accessMode === "OPEN" && !isAdmin;
	const isMobile = useIsMobile();
	return (
		<Container {...htmlProps}>
			<FeedContainer>
				<CreatePostInput groupId={group.id} />
				<FeedList groupId={group.id} />
			</FeedContainer>
			{!isMobile && (
				<MembersContainer>
					{/* {canSendInvitations && (
						<InvitationButton
							onClick={() => openMembersModal(I18n.t("group.DISCUSSION_GROUP.public.invitation_button"))}
						>
							{I18n.t("group.DISCUSSION_GROUP.public.invitation_button")}
						</InvitationButton>
					)} */}
					<GroupMembersList
						group={group}
						onShouldSeeMore={() =>
							history.push(
								group.type === "DISCUSSION_GROUP"
									? Path.Discussion(group, "community")
									: Path.Shareroom(group, "community")
							)
						}
					/>
				</MembersContainer>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: grid;
	column-gap: 45px;
	row-gap: 45px;
	grid-template-columns: minmax(0, 1fr) 280px;
	grid-template-rows: auto;
	grid-template-areas:
		"feed members"
		"feed members"
		"feed .";

	@media ${mobile} {
		grid-template-columns: 100%;

		grid-template-areas:
			"feed"
			"feed";
	}
`;

const FeedContainer = styled.div`
	grid-area: feed;
	${gap(40)};
`;

const MembersContainer = styled.div`
	grid-area: members;
`;
